export const sw_SW = {
    "PREFIX": {
        "QUESTION": "Swahili",
        "QUESTION-PART": "Swahili",
        "PRE-RELEASE": "Swahili",
        "JOURNAL": "Swahili"
    },
    "CONTENT": {
        "MARK": "Swahili"
    }
};
